var map = {
	"./cha-lr-1.png": "yoOO",
	"./cha-lr-2.png": "h1ox",
	"./cha-lr-3.png": "3q13",
	"./cha-lr-4.png": "sX3y",
	"./cha-lr-5.png": "oLjS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "atHV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha ^\.\/cha\-lr\-.*\.png$
// module id = atHV
// module chunks = 1